import React from 'react';
import { KeyRound } from 'lucide-react';
import { keycloakAccountManagement } from '../../services/keycloak';
import { AppButton } from '../ui/AppButton';
import { SectionCard } from '../ui/SectionCard';

/** Password, sign-in methods and sessions live in the Keycloak account console. */
export const SecurityCard = () => (
  <SectionCard
    title="Sign-in and security"
    subtitle="Your password, sign-in methods and active sessions are managed by LiveBetter single sign-on."
  >
    <AppButton variant="secondary" icon={<KeyRound size={14} aria-hidden="true" />} onClick={keycloakAccountManagement}>
      Open SSO account
    </AppButton>
  </SectionCard>
);
